import api from "../api.js";

// Public
export const submitContribution = async (data) => {
  const response = await api.post("/contributions", data);
  return response.data;
};

export const getApprovedContributions = async () => {
  const response = await api.get("/contributions");
  return response.data;
};

// Admin only
export const getAllContributions = async () => {
  const response = await api.get("/contributions/all");
  return response.data;
};

export const updateContributionStatus = async (id, status) => {
  const response = await api.patch(`/contributions/${id}`, { status });
  return response.data;
};